import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const Legend = (props) => {
  // Context
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )
  console.log(props)
  return (
    <div className="Legend">
      <ul className="Legend-list">
        {props.items.map((item, index) => {
          return (
            <li className="Legend-item" key={`Legend-item--${index}`}>
              <div className="Legend-imageWrapper">
                <img
                  src={`/images/legend/${userContext.sportType}/${item.icon}.png`}
                  alt={t(item.label)}
                  className="Legend-image"
                  loading="lazy"
                />
              </div>
              <div className="Legend-labelWrapper">
                <span className="Legend-label">{t(item.label)}</span>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

Legend.propTypes = {
  items: PropTypes.array
}

export default Legend
